module.exports = __webpack_public_path__ + "static/media/perdidas_lucha_resistencia.480612ae.md";